import { render, staticRenderFns } from "./UnknownResultsBody.vue?vue&type=template&id=4de01c99&scoped=true&"
import script from "./UnknownResultsBody.vue?vue&type=script&lang=js&"
export * from "./UnknownResultsBody.vue?vue&type=script&lang=js&"
import style0 from "./UnknownResultsBody.vue?vue&type=style&index=0&id=4de01c99&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de01c99",
  null
  
)

export default component.exports